import { callerCreator } from "../callerCreator";
import { aboutSlice } from "./aboutSlice";

export default callerCreator(aboutSlice.actions);
